import {inject} from '@angular/core';
import {CanMatchFn, Route, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { filter, map, tap } from 'rxjs/operators';

export const authMatchGuard: CanMatchFn = (route: Route) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return new Observable(observer => {
        authService.getUserEvents().pipe(
            filter(user => user !== undefined),
            map(user => user !== null),
            tap(isAuthenticated => {
                if (!isAuthenticated) {
                    router.navigate(['/auth']).then();
                }
            })
        ).subscribe(
            user => {
                observer.next(user);
                observer.complete();
            }, e => {
                observer.error(e);
                observer.complete();
            }
        );
    });
};
